<template>
  <div class="tree-menu">
    <v-row :class="[children && children.length > 0 ? 'label' : 'last-item-label']">
      <v-col class="pa-0" md="auto">
        <v-icon v-if="children && children.length > 0 && !showChildren" color="white" @click="toggleChildren">
          mdi-menu-right
        </v-icon>
        <v-icon v-else-if="children && children.length > 0 && showChildren" color="white" @click="toggleChildren">
          mdi-menu-down
        </v-icon>
      </v-col>
      <v-col class="pa-0" md="auto">
        <v-checkbox
          :id="`${parentCategory}-${name}`"
          hide-details
          on-icon="mdi-checkbox-intermediate"
          off-icon="mdi-square-rounded-outline"
          class="ma-0 pa-0"
          color="warning"
          dark
          @change="valueChanged"
        />
      </v-col>
      <v-col class="pa-0 tree-row" md="auto">
        <v-icon
          v-if="children && children.length > 0 && level > 0"
          small
          class="mr-2"
          :class="`history-attribute-category-${name}`"
        >
          mdi-circle
        </v-icon>
        <span class="tree-item" :class="level === 0 ? 'top-category' : ''" :title="$t(`device.history.${name}`)">{{ $t(`device.history.${name}`) }}</span>
      </v-col>
    </v-row>
    <div :class="showChildren ? 'menu-opened' : 'menu-hidden'">
      <TreeMenu
        v-for="(item) in children"
        :key="item.name"
        :children="item.children"
        :name="item.name"
        :class="showChildren ? 'menu-opened' : 'menu-hidden'"
        :parentCategory="item.parentCategory"
        :level="item.level"
        @eventBusAddCat="eventBusAddCat"
        @eventBusDelCat="eventBusDelCat"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { PropType, ref } from 'vue';

interface DataItem {
    name: string;
    parentCategory?: string;
    level: number;
    children?: DataItem[];
}

const { children, name, parentCategory, level } = defineProps({
  children: {
    type: Array as PropType<DataItem[]>,
    default: () => ([])
  },
  name: {
    type: String,
    default: ''
  },
  parentCategory: {
    type: String,
    default: ''
  },
  level: {
    type: Number,
    default: 0
  }
});

const emit = defineEmits(['eventBusAddCat', 'eventBusDelCat']);

const showChildren = ref(false);

function toggleChildren() {
  showChildren.value = !showChildren.value;
}

function eventBusAddCat(event: string) {
  emit('eventBusAddCat', event);
}

function eventBusDelCat(event: string) {
  emit('eventBusDelCat', event);
}

function handleChildrenSelection(checked: boolean, grand: string, parent: string) {
  const allChildren = document.querySelectorAll(`[id^="${grand}_${parent}-"]`);
  allChildren.forEach((el) => {
    const childChecked: boolean = el.getAttribute('aria-checked') === 'true';
    const parentChecked = checked;
    if (parentChecked && !childChecked) {
      (el as HTMLInputElement).click();
    } else if (!parentChecked && childChecked) {
      (el as HTMLInputElement).click();
    }
  });
}

// Clicking on a level 0 checkbox will click on immediate children (level 1)
// this will run handleChildrenSelection and select all level 3 children
function handleAllSelection(checked: boolean, parent: string) {
  children.forEach((child) => {
    const level1 = document.querySelector(`[id="${parent}-${child.name}"]`);
    (level1 as HTMLElement).click();
  });
}

function valueChanged(checked: boolean) {
  if (level === 0) {
    handleAllSelection(checked, parentCategory);
  } else if (level === 1) {
    handleChildrenSelection(checked, parentCategory, name);
  } else if (level === 2 && checked) {
    eventBusAddCat(name);
  } else if (level === 2 && !checked) {
    eventBusDelCat(name);
  }
}

</script>

<style lang="scss" scoped>
@import './styles/tree-menu.scss';
</style>
